/**
 * Agent Message Component
 * Displays the latest message from Anouk
 */

import { motion, AnimatePresence } from 'framer-motion';
import { Card } from '@/components/ui/Card';
import type { AgentMessageProps } from '@/types';
import { fadeInUp } from '@/utils/constants';

export function AgentMessage({ message }: AgentMessageProps) {
  if (!message) return null;

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={message}
        variants={fadeInUp}
        initial="initial"
        animate="animate"
        exit="exit"
        className="max-w-2xl w-full px-4"
      >
        <Card variant="glass" className="p-6 shadow-2xl">
          <div className="flex items-start space-x-4">
            {/* Avatar */}
            <div className="flex-shrink-0">
              <div className="w-12 h-12 rounded-full bg-nomade-primary/20 backdrop-blur-md flex items-center justify-center text-2xl">
                🧭
              </div>
            </div>

            {/* Message Content */}
            <div className="flex-1 min-w-0">
              <div className="flex items-center space-x-2 mb-2">
                <h3 className="text-lg font-semibold text-gray-900">Anouk</h3>
                <span className="text-xs text-gray-500">Agent Nomade</span>
              </div>
              <p className="text-gray-700 leading-relaxed">{message}</p>
            </div>
          </div>
        </Card>
      </motion.div>
    </AnimatePresence>
  );
}
